import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss']
})
export class OrderItemComponent implements OnInit {

  @Input("product") product = null;

  constructor(){}

  /**
   * 
   * Show
   * 
   */
  _show(){

    this.product.show = this.product.show ? false : true;

  }
  /***
   * 
   * Init
   * 
   **/
  ngOnInit():void{}

}
